import { motion } from 'framer-motion'
import './AnimatedBackground.css'

export default function AnimatedBackground({ text }) {
  return (
    <div className="animated-background">
      <div className="gradient-overlay" />
      <motion.div 
        className="floating-text"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 0.1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {text}
      </motion.div>
      <div className="gradient-orb orb-1" />
      <div className="gradient-orb orb-2" />
    </div>
  )
}

